<script setup lang="ts">
withDefaults(
  defineProps<{
    checked?: boolean
    houseCount?: number
    images?: string[]
    title: string
  }>(),
  {
    checked: false,
    houseCount: 0,
    images: () => [],
  },
)
</script>

<template>
  <div
    :class="[
      'flex cursor-pointer items-center rounded border p-1',
      { 'border-secondary-400': checked },
      { 'border-gray-200': !checked },
    ]"
  >
    <WishlistMultipleCardGridImages
      :house-count="houseCount"
      :images="images"
      :size-text-change-responsive="false"
      class="w-[100px]"
      small-icon
    />
    <div class="w-[calc(100%-128px)] grow px-4">
      <div class="mb-1 truncate font-bold text-gray-700">{{ title }}</div>
      <div class="text-gray-500">
        {{
          $t('wishlistMultiple.houseCount', { count: houseCount }, houseCount)
        }}
      </div>
    </div>
    <div>
      <span
        :class="[
          'mr-4 block size-3 rounded-full ring-1 ring-offset-2',
          { 'bg-secondary-400 ring-secondary-400': checked },
          { 'bg-transparent ring-gray-300': !checked },
        ]"
      />
    </div>
  </div>
</template>
